import { render, staticRenderFns } from "./totalCupons.vue?vue&type=template&id=75867ffa&scoped=true"
import script from "./totalCupons.vue?vue&type=script&lang=js"
export * from "./totalCupons.vue?vue&type=script&lang=js"
import style0 from "./totalCupons.vue?vue&type=style&index=0&id=75867ffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75867ffa",
  null
  
)

export default component.exports